import { ProgressIndicator } from "../../../../widgets"
import { QRCodeCanvas } from "qrcode.react"
import { ServiceRequestStatus } from "../models"
import { useGetServiceRequestGatePassId } from "../helpers"
import { useServiceRequestContext } from "../service-request"

export const GatePassQRCode = () => {
    const { result } = useServiceRequestContext()
    const { serviceRequest } = result || {}
    const { gatePassId } = useGetServiceRequestGatePassId(serviceRequest)

    if (serviceRequest?.statusCode !== ServiceRequestStatus.Approved && serviceRequest?.statusCode !== ServiceRequestStatus.AutoApproved)
        return <></>

    if (!gatePassId)
        return <ProgressIndicator show={true} message="Loading QR Code ..." />

    const qrCodeContainerStyle = {
        backgroundColor: 'white',
        padding: '10px', 
        borderRadius: '8px', 
        display: 'inline-block'
    }

    return <div className="d-flex align-items-center justify-content-center">
        <div className="card my-3">
            <div className="card-header min-h-5px border-0 d-flex justify-content-center">
                <h6 className="my-3">Scan QR Code</h6>
            </div>
            <div className="card-body">
                <div style={qrCodeContainerStyle}>
                    <QRCodeCanvas value={gatePassId} size={150} />
                </div>
            </div>
        </div>
    </div>
}
